import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { UPDATE_DMX_DEVICE_PRESET } from './actionTypes';
import { updateDmxDevicePresetSuccessful, updateDmxDevicePresetFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* updateDevicePreset({ payload: { preset } }) {
  try {
    const response = yield call(dmxAPI.updateDevicePreset, preset.token, preset.deviceId, preset.id, preset);
    if (response.message) {
      yield put(updateDmxDevicePresetSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(updateDmxDevicePresetFailed(error));
  }
}

export function* watchUpdateDmxDevicePreset() {
  yield takeEvery(UPDATE_DMX_DEVICE_PRESET, updateDevicePreset);
}

function* updateDmxDevicePresetSaga() {
  yield all([fork(watchUpdateDmxDevicePreset)]);
}

export default updateDmxDevicePresetSaga;
